import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentApiModels } from '../../../../../models/api/document-api.models';
import { SubscriptionApiModels } from '../../../../../models/api/subscription-api.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { DocumentModels } from '../../../../../models/document.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'subscriptions');
  }

  getDocument(
    type: DocumentModels.DocumentType,
  ): Observable<DocumentApiModels.GetDocumentResponse> {
    return this.getJson('/documents', {
      docType: type.toString(),
    });
  }

  uploadFragment(
    type: DocumentModels.DocumentType,
    file: File,
  ): Observable<number> {
    return this.postFormData<number>('/documents/fragments', {
      documentType: type,
      file,
    });
  }

  getBrokerSubscription(): Observable<SubscriptionApiModels.GetSubscriptionResponse> {
    return this.getJson<SubscriptionApiModels.GetSubscriptionResponse>('');
  }

  saveBrokerSubscription(form: SubscriptionApiModels.PostSubscriptionRequest) {
    return this.put('', form);
  }

  getSubscriptionDocumentInformations(
    agencyId: number,
    documentType: DocumentModels.DocumentType,
  ): Observable<SubscriptionApiModels.GetSubscriptionDocumentInformationsResponse> {
    return this.getJson<SubscriptionApiModels.GetSubscriptionDocumentInformationsResponse>(
      `/documents/${agencyId}/informations`,
      { documentType },
    );
  }

  postSubscriptionDocumentInformations(
    agencyId: number,
    documentType: DocumentModels.DocumentType,
    information: SubscriptionApiModels.PostSubscriptionDocumentInformationsRequest,
  ): Observable<void> {
    return this.post(
      `/documents/${agencyId}/informations/${documentType}`,
      information,
    );
  }
}
